import { omit } from 'util/object'

export function updateSearchParams(update: Record<string, unknown>): void {
  const old = Object.fromEntries(new URLSearchParams(location.search))
  const params = new URLSearchParams(omit({ ...old, ...update }) as any).toString()
  const path = location.pathname
  const search = params ? '?' + params : ''
  history.replaceState({}, '', path + search)
}
